import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '../components';
import { Search } from 'lucide-react';

export const ProfessionalSearchRequestsPage: React.FC = () => {
  const { t } = useTranslation('pages');
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">{t('professionalSearchRequests.title')}</h1>
        <p className="mt-1 text-gray-600">{t('professionalSearchRequests.subtitle')}</p>
      </div>

      <Card>
        <div className="text-center py-12">
          <Search className="mx-auto h-16 w-16 text-gray-400 mb-4" />
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            {t('professionalSearchRequests.title')}
          </h2>
          <p className="text-gray-600">{t('underConstruction')}</p>
        </div>
      </Card>
    </div>
  );
};
